// extracted by mini-css-extract-plugin
export var badge = "_sn-4";
export var selected = "_sn-1";
export var selectedOverlay = "_sn-5";
export var thumbnailButton = "_sn-0";
export var thumbnailFallback = "_sn-3";
export var thumbnailImage = "_sn-2";